import * as React from "react"

const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="Layer_1"
    width={483.006}
    height={97.048}
    viewBox="0 0 148.4 29.813"
    {...props}
  >
    <style id="style148">{".st0{fill:#77bc1f}"}</style>
    <g id="g1059" transform="matrix(1.16123 0 0 1.16123 -39.752 -152.428)">
      <path
        id="path4948-6"
        d="M42.486 131.255h12.61a4.726 4.726 0 0 1 .937.092 4.65 4.65 0 0 1 .904.275 4.785 4.785 0 0 1 2.025 1.58 4.995 4.995 0 0 1 .379.598 4.787 4.787 0 0 1 .568 2.27c0 2.036-.615 3.808-1.844 5.318a7.81 7.81 0 0 1-1.956 1.724l2.208 1.99a4.693 4.693 0 0 1 .673.748 4.628 4.628 0 0 1 .395.644 5.177 5.177 0 0 1 .205.46 4.96 4.96 0 0 1 .26.972 4.638 4.638 0 0 1 .06.753c0 2.342-.755 4.296-2.264 5.86-1.536 1.595-3.532 2.393-5.99 2.393h-9.17c-2.598 0-4.635-.738-6.11-2.213a4.883 4.883 0 0 1-.15-.158c-1.329-1.455-1.993-3.416-1.993-5.882v-9.17c0-2.233.58-4.045 1.743-5.438 1.501-1.877 3.671-2.816 6.51-2.816zm12.61 1.604h-12.61c-2.324 0-4.077.738-5.257 2.214-.928 1.112-1.391 2.59-1.391 4.435v9.17c0 2.052.524 3.652 1.573 4.8.032.037.066.072.1.106 1.162 1.162 2.82 1.743 4.975 1.743h9.17c2.003 0 3.614-.634 4.834-1.9 1.21-1.255 1.815-2.838 1.815-4.749a3.345 3.345 0 0 0-.07-.666 3.378 3.378 0 0 0-.143-.484 3.084 3.084 0 0 0-.304-.597 3.47 3.47 0 0 0-.308-.4 3.209 3.209 0 0 0-.236-.237l-3.075-2.77a1.22 1.22 0 0 1-.056-.056l-.025-.03a.753.753 0 0 1-.122-.2.764.764 0 0 1-.061-.268.653.653 0 0 1 .002-.118.886.886 0 0 1 .043-.192.844.844 0 0 1 .134-.24.797.797 0 0 1 .316-.235 6.093 6.093 0 0 0 2.422-1.814c.988-1.212 1.483-2.646 1.483-4.302a3.326 3.326 0 0 0-.062-.625 2.995 2.995 0 0 0-.126-.456 3.115 3.115 0 0 0-.354-.702 3.126 3.126 0 0 0-.513-.595 3.182 3.182 0 0 0-.926-.587 3.021 3.021 0 0 0-.45-.148 3.143 3.143 0 0 0-.779-.096z"
        style={{
          fill: "#4ec3e0",
          fillOpacity: 1,
          strokeWidth: 1.01081,
          strokeDasharray: "none",
        }}
      />
      <path
        id="path4910-5"
        d="M39.644 136.776c.567-.71 1.513-1.04 2.837-1.04h13.003c0 .921-.26 1.702-.78 2.34-.639.78-1.56 1.182-2.767 1.206h-9.456v9.456h7.707l-4.894-4.397c.899-.875 1.75-1.324 2.506-1.348.804-.047 1.702.355 2.672 1.23l5.012 4.515c0 1.088-.308 1.939-.946 2.6-.615.64-1.49.947-2.6.947H42.48c-1.324 0-2.246-.284-2.79-.828-.496-.544-.756-1.442-.756-2.719v-9.456c0-1.111.236-1.939.709-2.506z"
        style={{
          display: "inline",
          fill: "#ff5c00",
          fillOpacity: 1,
          strokeWidth: 1.04238,
          strokeDasharray: "none",
        }}
      />
      <path
        id="path1325-6"
        d="m65.658 131.255-.02 25.481v-.357"
        style={{
          fill: "none",
          fillOpacity: 1,
          fillRule: "evenodd",
          stroke: "#4ec3e0",
          strokeWidth: 0.412251,
          strokeDasharray: "none",
          strokeOpacity: 1,
        }}
      />
      <text
        xmlSpace="preserve"
        id="text270-9"
        x={70.312}
        y={147.494}
        style={{
          fontStyle: "normal",
          fontVariant: "normal",
          fontWeight: 400,
          fontStretch: "normal",
          fontSize: "19.4028px",
          fontFamily: "&quot",
          InkscapeFontSpecification: "&quot",
          fill: "red",
          fillRule: "evenodd",
          stroke: "#ff5c00",
          strokeWidth: 0.465,
          strokeDasharray: "none",
          strokeOpacity: 1,
        }}
      >
        <tspan
          id="tspan268-3"
          x={70.312}
          y={147.494}
          style={{
            fontStyle: "normal",
            fontVariant: "normal",
            fontWeight: 400,
            fontStretch: "normal",
            fontSize: "19.4028px",
            fontFamily: "&quot",
            InkscapeFontSpecification: "&quot",
            stroke: "#ff5c00",
            strokeWidth: 0.465,
            strokeDasharray: "none",
            strokeOpacity: 1,
          }}
        >
          <tspan
            id="tspan1102-7"
            style={{
              fontSize: "19.4028px",
              fill: "#ff5c00",
              fillOpacity: 1,
              stroke: "#ff5c00",
              strokeOpacity: 1,
            }}
          >
            {"GTOR"}
          </tspan>
          <tspan
            id="tspan996-4"
            style={{
              fontSize: "19.4028px",
              fill: "none",
              stroke: "#ff5c00",
              strokeWidth: 0.465,
              strokeDasharray: "none",
              strokeOpacity: 1,
            }}
          >
            {"RES"}
          </tspan>
        </tspan>
      </text>
      <text
        xmlSpace="preserve"
        id="text4799-5"
        x={70.749}
        y={154.211}
        style={{
          fontStyle: "normal",
          fontVariant: "normal",
          fontWeight: 400,
          fontStretch: "normal",
          fontSize: "5.64444px",
          lineHeight: 0,
          fontFamily: "&quot",
          InkscapeFontSpecification: "&quot",
          letterSpacing: "7.02998px",
          display: "inline",
          fill: "#4ec3e0",
          fillOpacity: 1,
          fillRule: "evenodd",
          stroke: "none",
          strokeWidth: 0.465,
          strokeDasharray: "none",
          strokeOpacity: 1,
        }}
      >
        <tspan
          id="tspan4797-2"
          x={70.749}
          y={154.211}
          style={{
            fontSize: "5.64444px",
            display: "inline",
            fill: "#4ec3e0",
            fillOpacity: 1,
            stroke: "none",
            strokeWidth: 0.465,
            strokeDasharray: "none",
            strokeOpacity: 1,
          }}
        >
          {"DEVELOPER"}
        </tspan>
      </text>
    </g>
  </svg>
)

export default SvgComponent
